<template>
  <div class="login">
    <md-field>
      <md-input-item ref="input0" v-model="userName" placeholder="请输入用户名/邮箱"
        @change="checkBankCard">
        <img src="@/assets/image/icon_email.png" alt="" slot="left" class="logo" />
        <p v-if="isError" class="error" slot="error">
          请输入用户名/邮箱/手机
        </p>
      </md-input-item>
      <md-input-item ref="input0" v-model="passWord" placeholder="請輸入密碼"
        :type="showpass ? 'password' : 'text'" @change="checkBankpassWord">
        <md-icon :name="showpass ? 'invisible' : 'visible'" size="lg" slot="right"
          @click="showpass = !showpass"></md-icon>
        <img src="@/assets/image/icon_pwd.png" alt="" slot="left" class="logo" />
        <p v-if="isErrorpas" class="error" slot="error">
          請輸入密碼
        </p>
      </md-input-item>
    </md-field>
    <div class="slider-verify">
      <div
        ref="sliderTrack"
        class="slider-track"
        :class="{ verified: sliderVerified }"
      >
        <div class="slider-text">{{ sliderVerified ? '验证通过' : '请按住滑块拖动' }}</div>
        <div
          ref="sliderHandle"
          class="slider-handle"
          :class="{ verified: sliderVerified }"
          :style="{ transform: 'translateX(' + sliderOffset + 'px)' }"
          @mousedown.prevent="startSlider"
          @touchstart.prevent="startSlider"
        >
          <md-icon :name="sliderVerified ? 'success' : 'arrow-right'" size="sm"></md-icon>
        </div>
      </div>
    </div>
    <div>
      <md-button :type="
          !isError && !isErrorpas && userName && passWord && sliderVerified
            ? 'warning'
            : 'disabled'
        " round style="width: 90%;margin-left: 5%;height: 0.9rem" @click="login">
        <md-activity-indicator v-if="loading" class="md-activity-indicator-css" type="carousel"
          :size="15" color="#fff" text-color="#fff"></md-activity-indicator>
        <span v-else>登录</span>
      </md-button>
    </div>
  </div>
</template>

<script>
import {
  ActivityIndicator,
  Button,
  Field,
  FieldItem,
  Icon,
  InputItem,
  Toast,
} from 'mand-mobile';
import md5 from 'js-md5';

export default {
  name: 'LoginModal',
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [FieldItem.name]: FieldItem,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      showpass: true,
      isError: false,
      isErrorpas: false,
      userName: '',
      loading: false,
      passWord: '',
      sliderOffset: 0,
      sliderVerified: false,
      sliderStartX: 0,
      sliderStartOffset: 0,
      sliderMaxOffset: 0,
    };
  },
  props: {
    // 店铺参数
    shopkey: {},
  },
  watch: {
    userName() {
      this.resetSlider();
    },
    passWord() {
      this.resetSlider();
    },
  },
  methods: {
    getClientX(event) {
      return event.touches ? event.touches[0].clientX : event.clientX;
    },
    startSlider(event) {
      if (this.sliderVerified || this.loading) {
        return;
      }
      const track = this.$refs.sliderTrack;
      const handle = this.$refs.sliderHandle;
      this.sliderStartX = this.getClientX(event);
      this.sliderStartOffset = this.sliderOffset;
      this.sliderMaxOffset = track.clientWidth - handle.offsetWidth;
      document.addEventListener('mousemove', this.moveSlider);
      document.addEventListener('mouseup', this.endSlider);
      document.addEventListener('touchmove', this.moveSlider, { passive: false });
      document.addEventListener('touchend', this.endSlider);
    },
    moveSlider(event) {
      event.preventDefault();
      const offset = this.sliderStartOffset + this.getClientX(event) - this.sliderStartX;
      this.sliderOffset = Math.max(0, Math.min(offset, this.sliderMaxOffset));
    },
    endSlider() {
      this.removeSliderListeners();
      if (this.sliderOffset >= this.sliderMaxOffset * 0.95) {
        this.sliderOffset = this.sliderMaxOffset;
        this.sliderVerified = true;
      } else {
        this.sliderOffset = 0;
      }
    },
    removeSliderListeners() {
      document.removeEventListener('mousemove', this.moveSlider);
      document.removeEventListener('mouseup', this.endSlider);
      document.removeEventListener('touchmove', this.moveSlider);
      document.removeEventListener('touchend', this.endSlider);
    },
    resetSlider() {
      this.sliderVerified = false;
      this.sliderOffset = 0;
    },
    checkBankpassWord() {
      if (!this.passWord) {
        this.isErrorpas = true;
      } else {
        this.isErrorpas = false;
      }
    },
    checkBankCard() {
      var reg = new RegExp(
        '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
      );
      if (!this.userName) {
        this.isError = true;
      } else {
        this.isError = false;
      }
    },
    login() {
      if (!this.sliderVerified) {
        Toast.failed('请先完成滑块验证');
        return;
      }
      this.loading = true;
      const par = {
        userName: this.userName.trim(),
        passWord: md5(this.passWord),
        shopCode: this.shopkey.appCode,
        countryId: this.$route.query.id
          ? this.$route.query.id
          : localStorage.getItem('firconteid'),
        registeredPlace: this.$route.query.pagename
          ? this.$route.query.pagename
          : localStorage.getItem('fircontename'),
      };
      this.http
        .APIASK(this.ports.appLogin, 'post', par)
        .then((res) => {
          if (res.object) {
            localStorage.setItem('couplist', JSON.stringify(res.object));
          }
          localStorage.setItem('mupressMobiltoken', res.accessToken);
          localStorage.setItem('refreshToken', res.refreshToken);
          const headerParams = {
            Authorization: res.accessToken,
            refreshToken: res.refreshToken,
            platform: 'H5',
            platformObj: {},
          };
          localStorage.setItem('headerParams', JSON.stringify(headerParams));
          this.getUserInfo();
        })
        .catch((err) => {
          this.loading = false;
          this.resetSlider();
        });
    },
    getUserInfo() {
      this.http
        .APIASK(this.ports.getUserInfo, 'get')
        .then((res) => {
          localStorage.setItem('userinfoMobie', JSON.stringify(res));
          this.loading = false;
          this.$emit('getnext');
        })
        .catch((err) => {
          this.loading = false;
          this.resetSlider();
        });
    },
  },
  beforeDestroy() {
    this.removeSliderListeners();
  },
};
</script>

<style lang="less">
.logo {
  width: 0.55rem;
  height: auto;
}
.error {
  text-align: left;
}
.slider-verify {
  padding: 0.1rem 5% 0.25rem;
}
.slider-track {
  position: relative;
  height: 0.76rem;
  overflow: hidden;
  border: 1px solid #d9dde3;
  border-radius: 0.1rem;
  background: #f1f3f6;
  color: #666;
  user-select: none;

  &.verified {
    border-color: #7fcf9a;
    background: #eefaf1;
    color: #37a35d;
  }
}
.slider-text {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  font-size: 0.26rem;
}
.slider-handle {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 0;
  display: flex;
  width: 0.76rem;
  height: 0.76rem;
  align-items: center;
  justify-content: center;
  border-right: 1px solid #d9dde3;
  background: #fff;
  color: #888;
  touch-action: none;

  &.verified {
    border-color: #7fcf9a;
    background: #55bd78;
    color: #fff;
  }
}
</style>
